import React from "react";
import { number, func } from "prop-types";
import ReactPaginate from "react-paginate";
import FontAwesome from "react-fontawesome";

const Pagination = ({
  totalPaginationPages,
  handlePageChange,
  currentPage,
}) => {
  const chevronLeft = <FontAwesome name="chevron-left" />;
  const chevronRight = <FontAwesome name="chevron-right" />;

  return (
    <div className="d-flex justify-content-center mt-3">
      <ReactPaginate
        pageCount={totalPaginationPages}
        perRangeDisplayed={5}
        marginPagesDisplayed={3}
        onPageChange={handlePageChange}
        forcePage={currentPage - 1}
        containerClassName="pagination"
        previousLabel={chevronLeft}
        nextLabel={chevronRight}
        previousClassName="previous-btn"
        nextClassName="next-btn"
        disabledClassName="disabled-btn"
      />
    </div>
  );
};

Pagination.propTypes = {
  totalPaginationPages: number,
  handlePageChange: func,
  currentPage: number,
};

export default Pagination;
